import { render, staticRenderFns } from "./BnLivraisonFourDetail.vue?vue&type=template&id=7b4ee3a2&"
import script from "./BnLivraisonFourDetail.vue?vue&type=script&lang=js&"
export * from "./BnLivraisonFourDetail.vue?vue&type=script&lang=js&"
import style0 from "./BnLivraisonFourDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports